/**
 * ArrowRight – SVG icon.
 */
import IArrow from '@shared/types/props/arrow';
import Screen from '@screen';

/** Right arrow with configurable size and color. */
export default function ArrowRightIcon({
  width = 31,
  height = 50,
  color = '#FFF',
}: IArrow) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${width * Screen.widthRatio}`}
      height={`${height * Screen.widthRatio}`}
      viewBox={'0 0 31 50'}
    >
      <path
        fill={color}
        fillRule='evenodd'
        stroke={color}
        d='M0.747896 1.01815C1.84246 -0.225668 3.73809 -0.346666 4.98191 0.747896L29.9819 22.7479C30.6291 23.3174 31 24.1379 31 25C31 25.8621 30.6291 26.6826 29.9819 27.2521L4.98192 49.2521C3.7381 50.3467 1.84246 50.2257 0.7479 48.9818C-0.346662 47.738 -0.225665 45.8424 1.01816 44.7478L23.4589 25L1.01815 5.25217C-0.225668 4.15761 -0.346667 2.26197 0.747896 1.01815Z'
      />
    </svg>
  );
}
